import _ from 'lodash';
import api from '../../../../scripts/api';
import { translate, translateText } from '../../../../scripts/core/tools/translate';
import { VehicleTypeEnum } from '../../../../scripts/core/vehicleType/constants';
import environment from '../../../../scripts/environment';
import { FeaturePermission } from '../../../../constants/feature.permission.helper';

export class LayersFilterFactory {
    constructor({ options, currentMap }) {
        this.options = options;
        this.currentMap = currentMap;
    }

    getData() {
        const data = [];
        const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);
        const hasTotalSales = environment.get("CONFIG.CLIENT_TOTAL_SALES");
        const typeSaleClassification = environment.get("CONFIG.FILTERS.TYPE_CLASSIFICATION_SALE");

        if (!this.options.fields) {
            return data;
        }

        let salesTypeDataSource = environment.get('CONFIG.FILTERS.SALES_TYPE');

        // DNC layer doesn't have TOTAL parameterd.
        if ((this.options.id.indexOf('filter-dnc') !== -1) || (this.options.id.indexOf('filter-dnc-flexible-0') !== -1)) {
            salesTypeDataSource = _.filter(salesTypeDataSource, x => x.value < 3);
        }

        if (this.options.id === 'filter-selected-areas-27') {
            data.push({
                name: 'pibYear',
                position: 1,
                fields: [
                    {
                        title: 'Ano Pib',
                        name: 'pibYear',
                        dataSource: [
                            { text: '2019', value: '2019' },
                            { text: '2018', value: '2018' },
                            { text: '2017', value: '2017' }
                        ],
                        value: 'value',
                        text: 'text',
                        type: 'dropdown',
                        index: 0,
                        noPlaceholder: true
                    }
                ]
            });

            data.push({
                name: 'pibTypes',
                position: 2,
                fields: [
                    {
                        title: 'Tipo PIB',
                        name: 'pibTypes',
                        dataSource: [
                            { text: 'Agrícola', value: '300' },
                            { text: 'Indústria', value: '301' },
                            { text: 'Serviços', value: '302' },
                            { text: 'Adm, defesa e seguridade social', value: '303' },
                            { text: 'Impostos', value: '304' }
                        ],
                        value: 'value',
                        text: 'text',
                        type: 'multiselect',
                        skipAll: false
                    }
                ]
            });
        }

        if (this.options.fields.sales
            && (
                (this.options.id.includes('filter-selected-areas') && isAuthorized(FeaturePermission.LAYER_LOCALES.filterSaleType))
                && !hasTotalSales
                || (this.options.id.includes('filter-marked-area') && isAuthorized(FeaturePermission.LAYER_AREA_CLIENT.filterSaleType))
                && !hasTotalSales
            )) {
            data.push({
                name: 'sales',
                position: 1,
                fields: [
                    {
                        title: translate('Common.Type'),
                        name: 'saleType',
                        dataSource: salesTypeDataSource,
                        value: 'value',
                        text: 'text',
                        type: 'dropdown',
                        index: 0,
                        noPlaceholder: true
                    }
                ]
            });
        }

        if (
            this.options.fields.channels
            && isAuthorized(FeaturePermission.SYSTEM.showDataDirect)
            && (
                (this.options.id.includes('filter-selected-areas') && isAuthorized(FeaturePermission.LAYER_LOCALES.filterSaleChannel))
                || (this.options.id.includes('filter-marked-area') && isAuthorized(FeaturePermission.LAYER_AREA_CLIENT.filterSaleChannel))
            )
        ) {
            data.push({
                name: 'channels',
                position: 2,
                fields: [
                    {
                        title: translate('Common.Channels'),
                        name: 'channels',
                        dataSource: _.map(environment.get('CONFIG.FILTERS.SALES_CHANNEL'), item => {
                            if (item.value === 0 && item.text === 'SELECIONAR TODOS') {
                                item.value = -9999;
                            }
                            return item;
                        }),
                        value: 'value',
                        text: 'text',
                        type: 'multiselect'
                    }
                ]
            });
        }

        if (
            this.options.fields.segments
            && (
                (this.options.id.includes('filter-selected-areas') && isAuthorized(FeaturePermission.LAYER_LOCALES.filterSegment))
                || (this.options.id.includes('filter-marked-area') && isAuthorized(FeaturePermission.LAYER_AREA_CLIENT.filterSegment))
            )
        ) {
            data.push({
                name: 'segments',
                data: _.reduce(environment.get('CONFIG.FILTERS.COMPETING_SEGMENTS'), (acc, val, key) => {
                    _.forEach(val, (v) => {
                        acc.push({
                            CD_CAT: key,
                            NM_CAT: key === 'competing' ? 'Competing' : 'Non Competing',
                            CD_SEGMENT: v.id,
                            NM_SEGMENT: translateText(v.nome, true)
                        });
                    });

                    return acc;
                }, []),
                position: 3,
                fields: [{
                    title: `${translate('Common.Classification')} ${translate('Common.Segment')}`,
                    name: 'competingClassification',
                    value: 'CD_CAT',
                    text: 'NM_CAT',
                    skipAll: true,
                    type: 'multiselect'
                }, {
                    title: translate('Common.Segments'),
                    name: 'models',
                    value: 'CD_SEGMENT',
                    text: 'NM_SEGMENT',
                    group: 'NM_CAT',
                    type: 'multiselect',
                    skipAll: true
                }]
            });
        }

        if (this.options.fields.companySizes
            && isAuthorized(FeaturePermission.SYSTEM.showDataDirect)
            &&
            (
                (this.options.id.includes('filter-selected-areas') && isAuthorized(FeaturePermission.LAYER_LOCALES.filterCompanySize))
                || (this.options.id.includes('filter-marked-area') && isAuthorized(FeaturePermission.LAYER_AREA_CLIENT.filterCompanySize))
            )) {
            data.push({
                name: 'companySizes',
                position: 5,
                fields: [
                    {
                        title: translate('Common.Port'),
                        name: 'companySizes',
                        dataSource: environment.get('CONFIG.FILTERS.COMPANY_SIZES'),
                        value: 'id',
                        text: 'text',
                        type: 'multiselect',
                        skipAll: true
                    }
                ]
            });
        }

        if (this.options.fields.fuelTypes
            &&
            (
                (this.options.id.includes('filter-selected-areas') && isAuthorized(FeaturePermission.LAYER_LOCALES.filterFuelType))
                || (this.options.id.includes('filter-marked-area') && isAuthorized(FeaturePermission.LAYER_AREA_CLIENT.filterFuelType))
            )) {
            data.push({
                name: 'fuelTypes',
                position: 6,
                fields: [{
                    title: translate('Common.FuelType'),
                    name: 'fuelTypes',
                    dataSource: _.map(environment.get('CONFIG.FILTERS.FUEL_TYPES'), (fuel) => ({ text: fuel.text, value: fuel.value })),
                    value: 'value',
                    text: 'text',
                    skipAll: true,
                    type: 'multiselect'
                }]
            });
        }

        if (this.options.fields.specializationIndustry
            && isAuthorized(FeaturePermission.LAYER_LOCALES.filterSpecializationIndustry)
            && environment.get('CONFIG.FILTERS.SPECIALIZATION_INDUSTRY_CONTEXT')
            && environment.get('CONFIG.FILTERS.SPECIALIZATION_INDUSTRY_CONTEXT').length) {
            data.push({
                name: 'industry',
                position: 6,
                visible: true,
                fields: [{
                    title: translate('Common.Industry'),
                    name: 'industry',
                    dataSource: environment.get('CONFIG.FILTERS.SPECIALIZATION_INDUSTRY_CONTEXT'),
                    value: 'id',
                    text: 'name',
                    type: 'dropdown'
                }]
            });
        }

        if (this.options.fields.groups && isAuthorized(FeaturePermission.LAYER_AREA_CLIENT.filterGroup)) {
            data.push({
                name: 'group',
                position: 3,
                visible: true,
                fields: [{
                    title: translate('Common.Group'),
                    name: 'group',
                    dataSource: _(environment.get('CONFIG.FILTERS.DEALERS_STORES'))
                        .map((val) => ({ text: val.Grupo, value: val.IdEconomicGroup }))
                        .uniqBy(val => val.text)
                        .orderBy(val => val.text)
                        .value(),
                    value: 'value',
                    text: 'text',
                    skipAll: true,
                    type: 'multiselect'
                }]
            });
        }

        if (this.options.fields.vehicleFleetArea) {
            const sourceSegments = environment.get('CONFIG.FILTERS.VEHICLEFLEETAREA_SEGMENTS_CLIENT');
            const sourceFuelTypes = environment.get('CONFIG.FILTERS.FUEL_TYPES_VEHICLE_FLEET');

            data.push(...[
                {
                    name: 'vehicletype_segments',
                    position: 1,
                    data: sourceSegments,
                    fields: [
                        // {
                        //     title: translate('Common.AfterSalesVehicleType'),
                        //     name: 'vehicleTypes',
                        //     value: 'vehicleTypeId',
                        //     text: 'vehicleTypeName',
                        //     type: 'dropdown'
                        // },
                        {
                            title: translate('Common.Segment'),
                            name: 'segmentsVehicleFleet',
                            value: 'segmentId',
                            text: 'segmentName',
                            type: 'multiselect',
                        },
                        // {
                        //     title: translate('Common.Brand'),
                        //     name: 'brandsVehicleFleet',
                        //     value: 'brandId',
                        //     text: 'brandName',
                        //     type: 'multiselect',
                        // },
                        {
                            title: translate('Common.Family'),
                            name: 'familiesVehicleFleet',
                            value: 'familyId',
                            text: 'familyName',
                            type: 'multiselect',
                        },
                        {
                            title: translate('Common.Model'),
                            name: 'modelsVehicleFleet',
                            value: 'modelId',
                            text: 'modelName',
                            type: 'multiselect',
                        },
                    ]
                },
                {
                    name: 'fuelTypesVehicleFleet',
                    position: 2,
                    data: sourceFuelTypes,
                    fields: [
                        {
                            title: translate('Common.AfterSalesFuelType'),
                            name: 'fuelTypesVehicleFleet',
                            value: 'id',
                            text: 'nome',
                            type: 'multiselect',
                        }
                    ]
                },

            ]);
        }

        if (this.options.fields.socialClass) {
            const sourceTypeSocialClass = environment.get('CONFIG.FILTERS.TYPE_SOCIAL_CLASS');

            const filter = {
                name: 'typeSocialClass',
                position: 1,
                data: sourceTypeSocialClass,
                fields: [
                    {
                        title: 'Classe Social',
                        name: 'typeSocialClass',
                        value: 'nome',
                        text: 'nome',
                        type: 'multiselect',
                    }
                ]
            };

            data.push(filter);
        }

        if (this.options.fields.typeSaleClassification
            &&
            (
                (this.options.id.includes('filter-selected-areas') && isAuthorized(FeaturePermission.LAYER_LOCALES.filterTypeSaleClassification))
                || (this.options.id.includes('filter-marked-area') && isAuthorized(FeaturePermission.LAYER_AREA_CLIENT.filterTypeSaleClassification))
            )
            &&
                typeSaleClassification !== undefined
            ) {
            data.push({
                name: 'typeSaleClassification',
                position: 8,
                fields: [{
                    title: translate('Common.TypeSaleClassification'),
                    name: 'typeSaleClassification',
                    dataSource: typeSaleClassification,
                    value: 'id',
                    text: 'name',
                    skipAll: true,
                    type: 'multiselect'
                }]
            });
        }

        if (this.options.fields.brands
            &&
            (
                (this.options.id.includes('filter-selected-areas') && isAuthorized(FeaturePermission.LAYER_LOCALES.filterBrand))
                || (this.options.id.includes('filter-marked-area') && isAuthorized(FeaturePermission.LAYER_AREA_CLIENT.filterBrand))
            )
        ) {
            if (_.isObject(this.options.fields.brands) && !this.options.fields.brands.visible) {
                return data;
            }

            const filter = {
                name: 'brands',
                data: environment.get('CONFIG.FILTERS.BRANDS'),
                position: 4,
                fields: []
            };

            const isMultiselect = this.options.fields.brands.type === 'multiselect';

            const brandFilter = {
                title: translate('Common.Brand'),
                name: 'brands',
                value: 'brandId',
                text: 'brand',
                type: this.options.fields.brands.type,
                skipAll: true
            };

            if (isMultiselect) {
                brandFilter.group = 'classification';
            }

            if (this.options.fields.brands.type === 'dropdown') {
                brandFilter.index =
                    _(environment.get('CONFIG.FILTERS.BRANDS'))
                        .uniqBy(b => b.brandId)
                        .findIndex(
                            b =>
                                String(environment.get('CONFIG.CLIENT')).toLowerCase() === String(b.brand).toLowerCase()
                        ) + 1;
            }
            filter.fields.push(brandFilter);

            if (isMultiselect
                && this.options.fields.classification
                && environment.get('CONFIG.USERVEHICLETYPE') === VehicleTypeEnum.Car) {
                filter.fields.unshift({
                    title: `${translate('Common.Classification')} ${translate('Common.Brand')}`,
                    name: 'classification',
                    value: 'classificationId',
                    text: 'classification',
                    skipAll: true,
                    type: 'multiselect'
                });
            }

            data.push(filter);
        }

        return data;
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/filters/factory/layers.factory.js